import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "trixEditor", "messageField", "recipientIds", "submitButton"]
  static values = {
    recipientType: String,
    successMessage: { type: String, default: "An email was successfully sent!" },
    errorMessage: { type: String, default: "Something went wrong. Please try again." }
  }

  connect() {
    this.setupFormListeners()
  }

  setupFormListeners() {
    this.formTarget.addEventListener('submit', this.validateSubmit.bind(this))

    // Handle form submission before
    this.formTarget.addEventListener('ajax:before', this.beforeSubmit.bind(this))

    // Handle success
    this.formTarget.addEventListener('ajax:success', this.handleSuccess.bind(this))

    // Handle error
    this.formTarget.addEventListener('ajax:error', this.handleError.bind(this))
  }

  validateSubmit(event) {
    if (this.hasTrixEditorTarget && this.hasMessageFieldTarget && !this.trixEditorTarget.value?.trim()) {
      event.preventDefault()
      event.stopPropagation()
      swal("Error", "Please enter a message.", "error")
    }
  }

  beforeSubmit(event) {
    // Sync Trix editor content to hidden textarea
    if (this.hasTrixEditorTarget && this.hasMessageFieldTarget) {
      const trixContent = this.trixEditorTarget.value
      this.messageFieldTarget.value = trixContent
    }

    // Populate recipient IDs
    this.populateRecipientIds()
  }

  populateRecipientIds() {
    // Check if batch_action_ids is defined globally (for batch actions from index pages)
    if (typeof batch_action_ids !== 'undefined' && batch_action_ids.length > 0) {
      // Remove existing recipient_ids fields
      this.formTarget.querySelectorAll('input[name="recipient_ids[]"]').forEach(field => field.remove())

      // Add new recipient_ids fields
      batch_action_ids.forEach(id => {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'recipient_ids[]'
        input.value = id
        this.formTarget.appendChild(input)
      })
    } else if (this.hasRecipientIdsTarget) {
      // For single record (show pages), check if there's a data attribute or hidden field
      const recipientId = this.recipientIdsTarget.value || this.recipientIdsTarget.dataset.recipientId

      if (recipientId) {
        // Remove existing recipient_ids fields
        this.formTarget.querySelectorAll('input[name="recipient_ids[]"]').forEach(field => field.remove())

        // Add single recipient_id field
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'recipient_ids[]'
        input.value = recipientId
        this.formTarget.appendChild(input)
      }
    }
  }

  handleSuccess(event) {
    const [data, status, xhr] = event.detail

    swal({
      title: "Alḥamdulillāh",
      type: "success",
      text: this.successMessageValue,
    }, () => {
      this.resetForm()
      this.closeModal()
      window.location.reload()
    })
  }

  resetForm() {
    this.formTarget.reset()
    if (this.hasTrixEditorTarget) {
      this.trixEditorTarget.editor.loadHTML('')
    }
  }

  handleError(event) {
    const [data, status, xhr] = event.detail
    let errorMessage = this.errorMessageValue

    if (data && data.error) {
      errorMessage = data.error
    }

    swal("Error", errorMessage, "error")
  }

  closeModal() {
    // Find the closest modal and close it
    const modal = this.element.closest('.modal')
    if (modal) {
      $(modal).modal('hide')
    }
  }

  disconnect() {
    // Clean up event listeners
    this.formTarget.removeEventListener('submit', this.validateSubmit.bind(this))
    this.formTarget.removeEventListener('ajax:before', this.beforeSubmit.bind(this))
    this.formTarget.removeEventListener('ajax:success', this.handleSuccess.bind(this))
    this.formTarget.removeEventListener('ajax:error', this.handleError.bind(this))
  }
}
